export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7463.760613f8.jpg";